'use client';
import React from 'react';

interface InfoCard {
  badge: string;
  title: string;
  description: string;
  backgroundColor: string;
}

interface InfoCardsSectionProps {
  className?: string;
  cards?: InfoCard[];
}

const InfoCardsSection: React.FC<InfoCardsSectionProps> = ({ 
  className = '',
  cards = []
}) => {
  const defaultCards: InfoCard[] = [
    {
      badge: '¿Eres profesional?',
      title: 'Ut enim ad minim veniam',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      backgroundColor: 'bg-global-3'
    },
    {
      badge: 'Recetas',
      title: 'PASTA TAGLIATELLE CON BURRATA\nY TOMATES',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      backgroundColor: 'bg-global-4'
    },
    {
      badge: 'Marcas',
      title: 'Sed ut perspiciatis unde\nomnis iste natus',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      backgroundColor: 'bg-global-3'
    }
  ];

  const cardsToUse = cards.length > 0 ? cards : defaultCards;

  return (
    <div data-component-id="src/components/sections/InfoCardsSection.tsx:44:4" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="44" data-component-file="InfoCardsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${className}`}>
            <div data-component-id="src/components/sections/InfoCardsSection.tsx:45:12" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="45" data-component-file="InfoCardsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-3%20gap-8%20w-full%22%7D" className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
        {cardsToUse.map((card, index) => (
          <div data-component-id="src/components/sections/InfoCardsSection.tsx:47:10" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="47" data-component-file="InfoCardsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" key={index} className={`${card.backgroundColor} rounded-[20px] p-8`}>
              <div data-component-id="src/components/sections/InfoCardsSection.tsx:48:14" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="48" data-component-file="InfoCardsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-global-9%20rounded%20px-4%20inline-block%20mb-4%22%7D" className="bg-global-9 rounded px-4 inline-block mb-4">
                <span data-component-id="src/components/sections/InfoCardsSection.tsx:49:16" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="49" data-component-file="InfoCardsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-tt-norms-medium%20text-%5B22px%5D%20leading-%5B27px%5D%20text-global-1%22%7D" className="font-tt-norms-medium text-[22px] leading-[27px] text-global-1">
                  {card.badge}
                </span>
              </div>
              <h3 data-component-id="src/components/sections/InfoCardsSection.tsx:53:14" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="53" data-component-file="InfoCardsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-tt-norms-extra-black%20text-base%20leading-5%20uppercase%20text-global-1%20mb-2%22%7D" className="font-tt-norms-extra-black text-base leading-5 uppercase text-global-1 mb-2">
                {card.title}
              </h3>
              <p data-component-id="src/components/sections/InfoCardsSection.tsx:56:14" data-component-path="src/components/sections/InfoCardsSection.tsx" data-component-line="56" data-component-file="InfoCardsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-tt-norms-medium%20text-base%20leading-%5B21px%5D%20text-global-1%22%7D" className="font-tt-norms-medium text-base leading-[21px] text-global-1">
                {card.description}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default InfoCardsSection; 